<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M20 30a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clip-rule="evenodd"/><path d="M18.816 23.22a.923.923 0 01-.2-.298.922.922 0 01-.116-.449v-3.549a.924.924 0 111.849 0v3.214l2.284 2.284a.925.925 0 01-1.308 1.307l-2.509-2.509z"/><path fill-rule="evenodd" d="M20.827 10.775h3.11V13H26V9.449a1.67 1.67 0 00-.503-1.193l-5.869-5.762A1.735 1.735 0 0018.413 2H5.72C4.769 2 4 2.756 4 3.688v23.625C4 28.244 4.77 29 5.719 29H11v-2.025H6.062V4.025h11v3.038c0 2.044 1.684 3.703 3.765 3.712zm2.256-2.025l-3.958-3.886v2.199c0 .928.764 1.681 1.708 1.687h2.25z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'filesHistoryOutline'
}
</script>
